var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "day-configurator-planning",
      class: {
        "read-only": _vm.isReadOnly,
        "no-schedule": !_vm.hasSchedule && !_vm.isReadOnly
      }
    },
    [
      _c("div", { ref: "leftColumn", staticClass: "left-column" }, [
        _c(
          "div",
          { staticClass: "title-container px-16 py-24 px-md-40 py-md-32" },
          [
            _c("div", { staticClass: "simple-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.translations.day_planning.my_day))])
            ]),
            _vm._v(" "),
            _vm.schedule.date_object != null
              ? _c("div", { staticClass: "expanded-title" }, [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-items-center mb-16",
                      class: _vm.canEdit
                        ? "justify-content-between"
                        : "justify-content-center"
                    },
                    [
                      _c("h2", { staticClass: "d-inline-block mb-0" }, [
                        _vm._v(_vm._s(_vm.formattedDate))
                      ]),
                      _vm._v(" "),
                      _vm.canEdit
                        ? _c(
                            "a",
                            {
                              staticClass: "text-accent",
                              on: {
                                click: function($event) {
                                  return _vm.$emit("previous-step")
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.translations.day_planning.modify)
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "subtitle",
                      class: { "text-center": _vm.isReadOnly }
                    },
                    [
                      _vm.address
                        ? [
                            _vm._v(
                              "\n                        " + _vm._s(_vm.address)
                            ),
                            _c(
                              "span",
                              { staticClass: "d-inline-block mx-16" },
                              [_vm._v("•")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(
                        _vm._s(_vm.formattedAttendees) + "\n                "
                      )
                    ],
                    2
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "time-planning-container px-16 pt-16 pb-80 px-md-40 pt-md-24 pb-md-96"
          },
          [
            _vm.canEdit
              ? _c("div", { staticClass: "mb-32" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-wrap add-buttons mb-n16" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "mr-12 mr-md-16 mb-12 mb-md-16 order-0",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showAddPopup("activity")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "d-inline-block mr-8" }, [
                            _vm._v(
                              _vm._s(
                                _vm.translations.day_planning.activity.icon
                              )
                            )
                          ]),
                          _vm._v(
                            _vm._s(_vm.translations.day_planning.activity.label)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "mr-12 mr-md-16 mb-12 mb-md-16 order-2 order-md-1",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showAddPopup("catering")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "d-inline-block mr-8" }, [
                            _vm._v(
                              _vm._s(
                                _vm.translations.day_planning.catering.icon
                              )
                            )
                          ]),
                          _vm._v(
                            _vm._s(_vm.translations.day_planning.catering.label)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "mr-12 mr-md-16 mb-12 mb-md-16 order-1 order-md-2",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showAddPopup("break")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "d-inline-block mr-8" }, [
                            _vm._v(
                              _vm._s(_vm.translations.day_planning.break.icon)
                            )
                          ]),
                          _vm._v(
                            _vm._s(_vm.translations.day_planning.break.label)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "mb-12 mb-md-16 order-3",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showAddPopup("own_activity")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "d-inline-block mr-8" }, [
                            _vm._v(
                              _vm._s(
                                _vm.translations.day_planning.own_activity.icon
                              )
                            )
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm.translations.day_planning.own_activity.label
                            )
                          )
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("day-configurator-time-planning", {
              staticClass: "mb-32",
              attrs: {
                start: 8,
                end: 22,
                items: _vm.items,
                "slots-per-hour": 4
              }
            }),
            _vm._v(" "),
            _vm.canEdit ||
            (_vm.schedule.gifts &&
              _vm.schedule.gifts.length > 0 &&
              _vm.getExternalItem(_vm.schedule.gifts[0]) != null)
              ? [
                  _c("h2", { staticClass: "mb-16" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.translations.day_planning.gift.title) +
                        _vm._s(_vm.schedule.gifts.length > 1 ? "s" : "") +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.schedule.gifts && _vm.schedule.gifts.length > 0
                    ? _vm._l(_vm.schedule.gifts, function(gift, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "gift mb-16 d-flex align-items-center"
                          },
                          [
                            _vm.getExternalItem(_vm.schedule.gifts[index]) !=
                            null
                              ? _c("div", { staticClass: "d-flex" }, [
                                  _c("img", {
                                    staticClass:
                                      "thumbnail align-self-start align-self-md-center",
                                    attrs: {
                                      src: _vm.getExternalItem(
                                        _vm.schedule.gifts[index]
                                      ).acf.image.sizes.medium_large,
                                      alt: _vm.getExternalItem(
                                        _vm.schedule.gifts[index]
                                      ).post_title
                                        ? _vm.getExternalItem(
                                            _vm.schedule.gifts[index]
                                          ).post_title
                                        : _vm.getExternalItem(
                                            _vm.schedule.gifts[index]
                                          ).title.rendered
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex flex-column justify-content-center"
                                    },
                                    [
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.getExternalItem(
                                              _vm.schedule.gifts[index]
                                            ).post_title
                                              ? _vm.getExternalItem(
                                                  _vm.schedule.gifts[index]
                                                ).post_title
                                              : _vm.getExternalItem(
                                                  _vm.schedule.gifts[index]
                                                ).title.rendered
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.canEdit
                                        ? _c(
                                            "p",
                                            { staticClass: "actions mt-8" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "remove",
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.removeGift(
                                                        index
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.translations
                                                        .day_planning.gift
                                                        .remove
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canEdit
                    ? _c(
                        "a",
                        {
                          staticClass: "add-gift btn btn btn-outline-dark",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.showAddGiftPopup($event)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "font-weight-bold d-inline-block mr-8"
                            },
                            [_vm._v("+")]
                          ),
                          _vm._v(_vm._s(_vm.translations.day_planning.add_gift))
                        ]
                      )
                    : _vm._e()
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.canEdit
          ? _c("div", { staticClass: "floating-button" }, [
              _c(
                "div",
                {
                  staticClass: "add-button",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.showAddPopup("start")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "tooltip tooltip-left" }, [
                    _vm._v(_vm._s(_vm.translations.day_planning.activity.label))
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "icon",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.svg("add-button", "icon-add-button")
                      )
                    }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.canEdit
          ? _c("div", { staticClass: "request-offer w-100 d-md-none" }, [
              _c("a", {
                staticClass: "btn btn-accent w-100 text-white",
                domProps: {
                  innerHTML: _vm._s(_vm.translations.header.request_offer)
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.requestOffer($event)
                  }
                }
              })
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.canEdit
        ? _c(
            "div",
            {
              ref: "rightColumn",
              staticClass: "right-column p-24 px-md-40 py-md-32"
            },
            [
              _c("h2", { staticClass: "mb-8" }, [
                _vm._v(_vm._s(_vm.translations.day_planning.activities))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-24" }, [
                _vm._v(
                  "\n            Versleep een activiteit naar links in het tijdsschema om toe te\n            voegen aan je dagplanning. Klik op de titel om meer te lezen\n            over de activiteit.\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tag-row filter-tags mb-40" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "tag-col" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tag tag-accent-light tag-sm",
                      class: { active: _vm.filter === "activity" },
                      on: {
                        click: function($event) {
                          return _vm.setFilter("activity")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    Activiteit\n                "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tag-col" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tag tag-accent-light tag-sm",
                      class: { active: _vm.filter === "speaker" },
                      on: {
                        click: function($event) {
                          return _vm.setFilter("speaker")
                        }
                      }
                    },
                    [_vm._v("\n                    Spreker\n                ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row mb-16" },
                [
                  _vm._l(
                    _vm.items.activity.filter(function(a) {
                      return (
                        !a.acf.content.fixed_format ||
                        !a.acf.content.fixed_format.time_table
                      )
                    }),
                    function(activity) {
                      return [
                        _vm.filter === null || _vm.filter === "activity"
                          ? _c(
                              "div",
                              {
                                key: activity.id,
                                staticClass: "col-6 col-xl-4"
                              },
                              [
                                _c(
                                  "drag",
                                  {
                                    attrs: {
                                      "effect-allowed": "copy",
                                      "drop-effect": "copy",
                                      "transfer-data": {
                                        action: "drop-item",
                                        type: "activity",
                                        data: activity
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "draggable activity mb-32"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "ar mb-8",
                                            style: {
                                              "padding-top":
                                                (_vm.arHeight / _vm.arWidth) *
                                                  100 +
                                                "%"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  activity.acf.content.images[0]
                                                    .sizes.medium_large,
                                                alt: activity.post_name
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("a", {
                                          staticClass: "title",
                                          attrs: {
                                            href: _vm.route(
                                              "nl.activity",
                                              activity.post_name
                                            ),
                                            target: "_blank"
                                          },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              activity.post_title
                                                ? activity.post_title
                                                : activity.title.rendered
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "tag-row mt-12" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "tag-col" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "tag tag-accent-light tag-xs"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                        Activiteit\n                                    "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "image" },
                                        slot: "image"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "drag-message" },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.translations.day_planning
                                                    .drag_message
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.items.speaker, function(speaker) {
                    return [
                      _vm.filter === null || _vm.filter === "speaker"
                        ? _c(
                            "div",
                            { key: speaker.id, staticClass: "col-6 col-xl-4" },
                            [
                              _c(
                                "drag",
                                {
                                  attrs: {
                                    "effect-allowed": "copy",
                                    "drop-effect": "copy",
                                    "transfer-data": {
                                      action: "drop-item",
                                      type: "speaker",
                                      data: speaker
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "draggable activity mb-32" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ar mb-8",
                                          style: {
                                            "padding-top":
                                              (_vm.arHeight / _vm.arWidth) *
                                                100 +
                                              "%"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                speaker.acf.image.sizes
                                                  .medium_large,
                                              alt: speaker.post_name
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("a", {
                                        staticClass: "title",
                                        attrs: {
                                          href: _vm.route(
                                            "nl.speaker",
                                            speaker.post_name
                                          ),
                                          target: "_blank"
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            speaker.title.rendered
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "tag-row mt-12" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "tag-col" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "tag tag-accent-light tag-xs"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        Spreker\n                                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { attrs: { slot: "image" }, slot: "image" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "drag-message" },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.translations.day_planning
                                                  .drag_message
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tag-col" }, [
      _c("p", { staticClass: "filter-title" }, [_vm._v("Filter:")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }